import { motion } from 'framer-motion'
import clsx from 'clsx'

const Section = ({ 
  children, 
  title, 
  subtitle,
  className,
  animation = true,
  ...props 
}) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  }

  return (
    <motion.section
      initial={animation ? 'hidden' : false}
      whileInView={animation ? 'visible' : false}
      viewport={{ once: true, margin: '-100px' }}
      variants={animation ? containerVariants : {}}
      className={clsx('section-container', className)}
      {...props}
    >
      {(title || subtitle) && (
        <motion.div 
          variants={animation ? itemVariants : {}}
          className="text-center mb-16"
        >
          {subtitle && (
            <p className="text-primary-400 font-medium mb-2 uppercase tracking-wider text-sm">
              {subtitle}
            </p>
          )}
          {title && (
            <h2 className="text-4xl md:text-5xl font-display font-bold gradient-text">
              {title}
            </h2>
          )}
        </motion.div>
      )}
      {children}
    </motion.section>
  )
}

export default Section

